import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { format } from 'date-fns';

const AcademyWaitlist = () => {
  const [waitlist, setWaitlist] = useState([]);
  const [totalSubscribers, setTotalSubscribers] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const fetchWaitlist = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/academy-waitlist`);
      setWaitlist(response.data.waitlist);
      setTotalSubscribers(response.data.totalSubscribers);
    } catch (error) {
      setError('Error fetching waitlist');
    } finally {
      setIsLoading(false);
    }
  };

  const handleSendBulkEmail = async () => {
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/api/send-bulk-email`);
      alert('Bulk email sent successfully!');
    } catch (error) {
      alert('Failed to send bulk email.');
    }
  };

  const handleSendBulkWhatsApp = async () => {
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/api/send-whatsapp-bulk`);
      alert('Bulk WhatsApp messages sent successfully!');
    } catch (error) {
      alert('Failed to send WhatsApp messages.');
    }
  };

  useEffect(() => {
    fetchWaitlist();
  }, []);

  if (isLoading) {
    return (
      <div className="w-full px-4 sm:px-6 lg:px-8 py-6 max-w-7xl mx-auto">
        <div className="text-center">Loading...</div>
      </div>
    );
  }

  return (
    <div className="w-full px-4 sm:px-6 lg:px-8 py-6 max-w-7xl mx-auto">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 gap-4">
        {/* Bulk Entry Buttons */}
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
          <button
            onClick={handleSendBulkEmail}
            className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded"
          >
            Send Bulk Email
          </button>
          <button
            onClick={handleSendBulkWhatsApp}
            className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded"
          >
            Send Bulk WhatsApp
          </button>
        </div>
        <div className="bg-black text-white px-4 py-2 rounded">
          Total Subscribers: {totalSubscribers}
        </div>
      </div>

      {error && (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
          {error}
        </div>
      )}

      <div className="bg-white rounded-lg shadow-md overflow-hidden">
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Name</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Email</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">WhatsApp</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">State</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Joined Date</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {waitlist.map((entry) => (
                <tr key={entry._id} className="hover:bg-gray-50">
                  <td className="px-4 py-3 whitespace-nowrap">
                    {entry.firstName || '-'}
                  </td>
                  <td className="px-4 py-3 whitespace-nowrap">
                    {entry.email}
                  </td>
                  <td className="px-4 py-3 whitespace-nowrap">
                    {entry.whatsapp || '-'}
                  </td>
                  <td className="px-4 py-3 whitespace-nowrap">
                    {entry.state || '-'}
                  </td>
                  <td className="px-4 py-3 whitespace-nowrap text-sm">
                    {format(new Date(entry.joinedAt), 'MMM dd, yyyy')}
                  </td>
                </tr>
              ))}
              {waitlist.length === 0 && (
                <tr>
                  <td colSpan="5" className="px-4 py-3 text-center text-gray-500">
                    No subscribers yet
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default AcademyWaitlist;